// import React from "react";

// const BlogDescription = () => {
//   return (
//     <>
//       <section className="blogDescription bg-accent">
//         <div className="container flow-content">
//           <h2>Heading</h2>
//           <p>Publish Date</p>
//           <div className="blogDescription__body flow-content">
//             <p>
//               Lorem ipsum dolor, sit amet consectetur adipisicing elit.
//               Voluptatibus dolores aperiam voluptate quod cupiditate eos,
//               officia, est quidem, aliquid debitis tempora distinctio beatae
//               libero assumenda dicta sit suscipit nihil iure repudiandae ipsam
//               quibusdam eius obcaecati! Error dolor debitis voluptates.
//               Doloribus?
//             </p>
//             <h3>This is another Text</h3>
//             <p>
//               Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio
//               suscipit ullam commodi deleniti. Cum veniam similique doloremque
//               consequatur at omnis!
//             </p>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default BlogDescription;

import React from "react";
import { useParams } from "react-router-dom";
import { blogsdata, Blog } from "../../blogs/blogData"; // ✅ correct import
import ReactMarkdown from "react-markdown";

const BlogDescription = () => {
  const { id } = useParams<{ id: string }>();
  const blog: Blog | undefined = blogsdata.find(
    (b: Blog) => b.id === Number(id)
  );

  if (!blog) {
    return <h2>Blog not found</h2>;
  }

  return (
    <section className="blogDescription bg-accent">
      <div className="container flow-content">
        <h2>{blog.title}</h2>
        <p>{blog.date}</p>
        <div className="blogDescription__body flow-content">
          {/* If your blog content is markdown */}
          <ReactMarkdown>{blog.content}</ReactMarkdown>
        </div>
      </div>
    </section>
  );
};

export default BlogDescription;
